// Dedicated DEV QA organization only. This is an identifier, never a credential.
export const HABI_PILOT_ORGANIZATION_ID = '66d2739b-f71a-42da-8c13-b1df34599741';
export function habiOrganizationAllowed(id: unknown): boolean {
  return id === HABI_PILOT_ORGANIZATION_ID;
}
